import {FiCheck, FiX} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";

export const CheckMarkIcon = ({enabled}: {enabled: boolean}) =>
  enabled ? <Icon icon={FiCheck} className="pulse-color-green-600" /> : <Icon icon={FiX} className="text-danger" />;
